import { rootQueryKeys } from './rootQueryKeys.js';

const rootQueryPredicates = {
  resourceRootAll: (query) => query.queryKey[0] === rootQueryKeys.resourceRootList()[0],
  resourceRoot: (query, resourceId) => query.queryKey[0] === rootQueryKeys.resourceRoot(resourceId)[0]
};

export { rootQueryPredicates };
//# sourceMappingURL=rootQueryPredicates.js.map
